import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { PrimaryButton } from "office-ui-fabric-react";
import { useStyles } from "./style";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

export const NewTable = (props) => {
  const classes = useStyles();
  const checkedValueSuccess = () => {
    let value = !props.Opendata;
    props.handleclose(value);
  };
  const checkedValueError = () => {
    let error = !props.errorStatus;
    props.handleclose(error);
  };

  return (
    <div>
      {props.StateRespone === "success" ? (
        <div>
          <Grid item xs={12} className={classes.item}>
            <div className={classes.itemLeft}>
              <img src="assets/icons/success.svg" alt="donlowad-icon" />
            </div>
            <div className={classes.itemRight}>Tabla importada exitosamente</div>
          </Grid>
          <hr className={classes.hrTag}></hr>

          <Grid container direction="row" justify="center" alignItems="center" style={{ marginTop: "40px" }}>
            <PrimaryButton className={classes.button} onClick={() => checkedValueSuccess()}>
              <ArrowForwardIosIcon className={classes.forwardIcon} />
              {
                props.download === true ?
                  <span>
                    Hacer otra descarga
                  </span> :
                  <span>
                    Exportar nueva tabla
                  </span>
              }

            </PrimaryButton>
          </Grid>
        </div>
      ) : (
        <div>
          <Grid item xs={12} className={classes.item}>
            <div className={classes.itemLeft}>
              <img src="assets/icons/error.svg" alt="donlowad-icon" />
            </div>
            <div className={classes.itemRight}>{props.ErrorMessage ? <>No hay más información para mostrar.</> : <>Hubo un error, intentalo más tarde</>}</div>
          </Grid>
          <hr className={classes.hrTag}></hr>

          <Grid container direction="row" justify="center" alignItems="center" style={{ marginTop: "40px" }}>
            <PrimaryButton className={classes.button} onClick={() => checkedValueError()}>
              <ArrowForwardIosIcon className={classes.forwardIcon} />
              <span>
                Exportar nueva tabla
              </span>
            </PrimaryButton>
          </Grid>
        </div>
      )}
    </div>
  );
};
